const { upgradeArray } = require('../utils')

const SENDINGSMODERATION_STATUS = upgradeArray([ 'init', 'processing', 'success', 'error' ])

module.exports = {
  SENDINGSMODERATION_STATUS
}
